/* Studio Mottos navigation v1. No edits to Prestige's core JavaScript. */
(() => {
  if (window.smNavigationV1) return;
  window.smNavigationV1 = true;
  const desktop = matchMedia('(min-width: 1000px)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const syncDimmer = () => document.body.classList.toggle('sm-mega-menu-open',
    desktop.matches && !!document.querySelector('sm-menu-disclosure details[open]'));

  class SMMenuDisclosure extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.details = this.querySelector('details');
      this.summary = this.details?.querySelector(':scope > summary');
      if (!this.summary) return;
      this.summary.setAttribute('aria-expanded', 'false');
      const cancelClose = () => { clearTimeout(this.closeTimer); };
      const scheduleClose = () => {
        cancelClose();
        this.closeTimer = setTimeout(() => this.setOpen(false), 220);
      };
      const hover = () => desktop.matches && finePointer.matches && this.getAttribute('trigger') === 'hover';
      this.addEventListener('pointerenter', () => { cancelClose(); if (hover()) this.setOpen(true); }, { signal });
      this.addEventListener('pointerleave', (event) => {
        if (!hover()) return;
        const header = this.closest('.shopify-section--header');
        if (header?.contains(event.relatedTarget)) return;
        scheduleClose();
      }, { signal });
      this.querySelector('.sm-mega-menu')?.addEventListener('pointerenter', cancelClose, { signal });
      this.closest('.shopify-section--header')?.addEventListener('pointerleave', () => {
        if (hover()) scheduleClose();
      }, { signal });
      this.closest('.shopify-section--header')?.addEventListener('pointerenter', cancelClose, { signal });
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        const destination = this.summary.dataset.followLink;
        if (this.details.open && destination) { location.assign(destination); return; }
        this.setOpen(!this.details.open);
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.setOpen(false);
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          const restoreFocus = this.contains(document.activeElement);
          this.setOpen(false);
          if (restoreFocus) this.summary.focus();
        }
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.setOpen(false);
      }, { signal });
      this.details.addEventListener('toggle', syncDimmer, { signal });
      desktop.addEventListener('change', () => this.setOpen(false), { signal });
      this.closest('.header__primary-nav')?.addEventListener('pointerover', (event) => {
        const item = event.target.closest('.header__primary-nav-item');
        if (hover() && item && !item.contains(this)) this.setOpen(false);
      }, { signal });
    }
    setOpen(open) {
      if (!this.details) return;
      clearTimeout(this.closeTimer);
      if (open) this.querySelectorAll('[data-sm-filter-menu]').forEach(populate);
      if (open) document.querySelectorAll('sm-menu-disclosure').forEach(menu => {
        if (menu !== this) menu.setOpen(false);
      });
      this.details.open = open;
      this.details.setAttribute('aria-expanded', String(open));
      this.summary.setAttribute('aria-expanded', String(open));
      syncDimmer();
    }
    disconnectedCallback() { clearTimeout(this.closeTimer); this.controller?.abort(); syncDimmer(); }
  }
  if (!customElements.get('sm-menu-disclosure')) customElements.define('sm-menu-disclosure', SMMenuDisclosure);

  const pending = new Map();
  const normalize = value => value.trim().toLowerCase();
  function parseOptions(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const groups = Array.from(doc.querySelectorAll('.sm-filter-group'));
    const extract = names => {
      const group = groups.find(group => names.includes(normalize(group.querySelector('.sm-filter-title')?.textContent || '')));
      const seen = new Set();
      return Array.from(group?.querySelectorAll('label') || []).flatMap(node => {
        const input = node.querySelector('input[name][value]');
        const label = (node.querySelector('.sm-format-name, .sm-color-name, span:last-child')?.textContent || node.textContent).trim();
        if (!input || !label || seen.has(input.value)) return [];
        seen.add(input.value);
        return [{ name: input.name, value: input.value, label, swatch: node.querySelector('.sm-color-swatch')?.getAttribute('style') || '' }];
      });
    };
    return { living: extract(['living space']), format: extract(['format', 'orientation']), color: extract(['color', 'colour']) };
  }
  function loadOptions(source) {
    if (pending.has(source)) return pending.get(source);
    const key = 'sm-navigation-options-v1:' + source;
    const request = (async () => {
      try {
        const cached = JSON.parse(sessionStorage.getItem(key));
        if (cached && Date.now() - cached.time < 30 * 60 * 1000) return cached.options;
      } catch (_) { /* Storage may be unavailable. */ }
      const abort = new AbortController();
      const timeout = setTimeout(() => abort.abort(), 10000);
      let response;
      try { response = await fetch(source, { credentials: 'same-origin', signal: abort.signal }); }
      finally { clearTimeout(timeout); }
      if (!response.ok) throw new Error('Collection filters could not be loaded');
      const options = parseOptions(await response.text());
      try { sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), options })); } catch (_) {}
      return options;
    })();
    pending.set(source, request);
    request.catch(() => pending.delete(source));
    return request;
  }
  function makeLink(source, option, className) {
    const url = new URL(source, location.origin);
    url.search = '';
    url.searchParams.set(option.name, option.value);
    const link = document.createElement('a');
    link.href = url.pathname + url.search;
    link.className = className;
    return link;
  }
  async function populate(menu) {
    if (menu.dataset.smInitialized) return;
    menu.dataset.smInitialized = 'true';
    const targets = ['living', 'format', 'color'].map(kind => ({ kind, target: menu.querySelector(`[data-sm-${kind}]`) }));
    const empty = targets.filter(({target}) => target && (!target.children.length || target.querySelector('[data-sm-filter-seed]')));
    empty.forEach(({target}) => { if(!target.children.length)target.closest('.sm-mega-menu__discovery-block').hidden = true; });
    if (!empty.length) return;
    try {
      const sourceURL = new URL(menu.dataset.smSource, location.origin);
      if (sourceURL.origin !== location.origin) throw new Error('Filter source must be on this store');
      const source = sourceURL.pathname;
      const options = await loadOptions(source);
      if (!menu.isConnected) return;
      empty.forEach(({ kind, target }) => {
        let entries = options[kind];
        if (kind === 'format') entries = ['portrait', 'landscape', 'square'].flatMap(shape => {
          const aliases = { portrait: ['portrait', 'vertical'], landscape: ['landscape', 'horizontal'], square: ['square'] };
          const entry = entries.find(entry => aliases[shape].includes(normalize(entry.label)));
          return entry ? [{ ...entry, shape }] : [];
        });
        if(!entries.length && target.querySelector('[data-sm-filter-seed]'))return;
        const fragment=document.createDocumentFragment();
        entries.forEach(option => {
          const link = makeLink(source, option, 'sm-mega-menu__' + (kind === 'living' ? 'living-link' : kind));
          if (kind === 'living') link.textContent = option.label;
          else if (kind === 'format') {
            const shape = document.createElement('span');
            shape.className = 'sm-mega-menu__format-shape sm-mega-menu__format-shape--' + option.shape;
            shape.setAttribute('aria-hidden', 'true');
            const label = document.createElement('span');
            label.textContent = option.shape[0].toUpperCase() + option.shape.slice(1);
            link.append(shape, label);
          } else {
            link.setAttribute('aria-label', option.label);
            link.title = option.label;
            const swatch = document.createElement('span');
            swatch.className = 'sm-mega-menu__color-swatch';
            swatch.style.cssText = option.swatch;
            const colors = { 'gray': '#999', 'grey': '#999', 'beige': '#e7d7b5', 'brown': '#8a4e2f', 'gold': '#d79b00', 'navy': '#202080', 'rose gold': '#b76e79' };
            const name = normalize(option.label);
            if (colors[name]) swatch.style.background = colors[name];
            link.append(swatch);
          }
          fragment.append(link);
        });
        target.replaceChildren(fragment);
        target.closest('.sm-mega-menu__discovery-block').hidden = !target.children.length;
      });
    } catch (error) {
      delete menu.dataset.smInitialized;
      console.warn('[Studio Mottos navigation]', error.message);
    }
  }
  const observers = new WeakMap();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-sm-filter-menu]').forEach(menu => {
      populate(menu);
      menu.querySelectorAll('.sm-mega-menu__discovery-block').forEach(block => {
        const target = block.querySelector('[data-sm-living], [data-sm-format], [data-sm-color]');
        if (target && !target.children.length) block.hidden = true;
      });
    });
    scope.querySelectorAll('.shopify-section--header').forEach(section => {
      if (observers.has(section)) return;
      const observer = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--header-height', section.getBoundingClientRect().height.toFixed(2) + 'px');
      });
      observer.observe(section);
      observers.set(section, observer);
    });
    syncDimmer();
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observers.get(event.target)?.disconnect();
    observers.delete(event.target);
    requestAnimationFrame(syncDimmer);
  });
  document.addEventListener('shopify:block:select', event => event.target.closest('sm-menu-disclosure')?.setOpen(true));
})();

/* Warm only the menu the visitor is approaching; leave other panels lazy. */
(()=>{
 const warm=root=>{if(!root||navigator.connection?.saveData||/^(slow-)?2g$/.test(navigator.connection?.effectiveType||''))return;
  [...root.querySelectorAll('img[loading="lazy"]')].slice(0,6).forEach(img=>{img.fetchPriority='low';img.loading='eager';});};
 // Prepare six small images for the first desktop menu after the page has loaded.
 const prepare=()=>{if(!matchMedia('(min-width: 1000px)').matches||document.visibilityState==='hidden')return;
  const run=()=>warm(document.querySelector('sm-menu-disclosure'));
  if(window.requestIdleCallback)requestIdleCallback(run,{timeout:1500});else setTimeout(run,200);
 };
 if(document.readyState==='complete')prepare();else window.addEventListener('load',prepare,{once:true});
 const intent=event=>{const target=event.target.closest?.('sm-menu-disclosure > details > summary,[data-sm-mobile-next],[aria-controls="sidebar-menu"]');if(!target)return;
  const menu=target.closest('sm-menu-disclosure');if(menu){warm(menu);return;}
  const panel=target.getAttribute('data-sm-mobile-next');if(panel){warm(document.querySelector('[data-sm-mobile-panel="'+panel+'"]'));return;}
  warm(document.querySelector('[data-sm-mobile-panel="main"]'));
 };
 document.addEventListener('pointerover',intent,{passive:true});document.addEventListener('pointerdown',intent,{passive:true});document.addEventListener('focusin',intent);
})();
